import React, {FormEvent, useEffect, useState} from "react";
import "../components/Form.css";
import {loginRequest} from "../msalConfig";
import {useMsal} from "@azure/msal-react";
import ProjectDropdown from "../components/ProjectDropdown";
import ClipLoader from "react-spinners/ClipLoader";

const GenerateProject: React.FC = () => {
    const { instance } = useMsal();

    const [templateId, setTemplateId] = useState<string | null>(null);
    const [targetId, setTargetId] = useState("");
    const [description, setDescription] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true);

        const formData = new FormData(e.currentTarget);
        const targetId = formData.get("targetId")
        const description = formData.get("description");

        try {
            let authorizationToken = await instance.acquireTokenSilent(loginRequest)
                .then(response => { return response.accessToken; })

            if (!authorizationToken) {
                alert("Failed to acquire token.");
                return;
            }

            const submittedData = { templateId, targetId, description };

            const response = await fetch(process.env.REACT_APP_BACKEND_BASE_URL as string + "/projects/create", {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${authorizationToken}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(submittedData),
                credentials: 'include'
            });

            await handleResponse(response);

            setTargetId("");
            setDescription("");

        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleResponse = async (response: Response) => {
        switch (response.status) {
            case 200:
                alert("Project updated successfully");
                break;
            case 201:
                alert("Project created successfully.");
                break;
            case 401:
                alert("Not authorized. Please log in again.");
                break;
            case 404:
                alert("Template or target project not found.");
                break;
            case 409:
                alert("A project with this ID already exists.");
                break;
            case 429:
                alert("This project is already being generated.");
                break;
            case 500:
                alert("Server error. Please try again later.");
                break;
            default:
                alert(`Unexpected error (${response.status}).`);
                break;
        }
    };

    return (
        <div className="form-container">
            <form className="grid-form" onSubmit={handleSubmit}>
                <div className="form-item">
                    <label htmlFor="templateSelector">Template</label>
                    <ProjectDropdown onSelect={(project) => setTemplateId(project)} />
                </div>
                <div className="form-item">
                    <label>New Project</label>
                    <input className="inputfield" name="targetId" autoComplete="off" value={targetId} required={true} onChange={(e) => setTargetId(e.target.value)}/>
                </div>
                <div className="form-item full-width">
                    <label>Description</label>
                    <textarea className="description" name="description" maxLength={256} value={description} onChange={(e) => setDescription(e.target.value)}/>
                </div>
                <div className="form-item full-width">
                    <button className="submit-button" type="submit" disabled={isLoading}>
                        {isLoading ? <ClipLoader size={20} color="#fff" /> : "Create Project"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default GenerateProject;